var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0615 3.377L13.0615 15.1259C13.0615 15.6087 12.6701 16 12.1874 16C11.7046 16 11.3133 15.6087 11.3133 15.1259L11.3133 3.5773L9.92161 5.00644C9.58842 5.3486 9.04174 5.35832 8.6966 5.02822C8.34702 4.6939 8.33715 4.13867 8.67461 3.79212L11.6216 0.765775C12.0252 0.351363 12.6951 0.364744 13.0818 0.794939L15.7769 3.79331C16.1003 4.15317 16.0683 4.70774 15.7056 5.02797C15.3474 5.34416 14.8013 5.31262 14.4819 4.95729L13.0615 3.377Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.868019 1.7325C0.389604 1.7325 0.00177193 1.34466 0.00177193 0.866247C0.00177193 0.387832 0.389604 0 0.868019 0H7.87645C8.35487 0 8.7427 0.387832 8.7427 0.866247C8.7427 1.34466 8.35487 1.7325 7.87645 1.7325H0.868019Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00152683 5.19748C0.00152683 5.6759 0.389359 6.06373 0.867774 6.06373H5.25393C5.73234 6.06373 6.12018 5.6759 6.12018 5.19748C6.12018 4.71907 5.73234 4.33124 5.25393 4.33124H0.867774C0.389359 4.33124 0.00152683 4.71907 0.00152683 5.19748Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.867774 10.395C0.389359 10.395 0.00152588 10.0071 0.00152588 9.52872C0.00152588 9.05031 0.389358 8.66248 0.867773 8.66248H2.63165C3.11006 8.66248 3.4979 9.05031 3.4979 9.52872C3.4979 10.0071 3.11006 10.395 2.63165 10.395H0.867774Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00168896 13.86C0.00168896 14.3384 0.397367 14.7262 0.875781 14.7262C1.3542 14.7262 1.74987 14.3384 1.74987 13.86C1.74987 13.3815 1.3542 12.9937 0.875781 12.9937C0.397367 12.9937 0.00168896 13.3815 0.00168896 13.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.4be04d37355595865d90a6ed93c754f7.svg";
export { ForwardRef as ReactComponent };